export const getAcronym = (name: string): string => {
    const parenthesised = name.match(/\(([^)]+)\)/)
    if (parenthesised) return parenthesised[1]

    const words = name.split(' ').filter(Boolean)

    // A lone initial says nothing, so a one-word name stays whole.
    return words.length > 1 ? words.map((word) => word.charAt(0).toUpperCase()).join('') : name
}
